
<nav id="sidebar" class="sideBarNavigation desktopView active">
    <div class="custom-scrollbar">
        <ul id="accordion" class="nav nav-pills flex-column sidebarNavigation">
            <li class="nav-item" (click)="addClassActive()" *ngIf="schedulePermissionList == '23' || insACQschedulePermissionList == '46' || insuranceFormschedulePermissionList == '65' || mceschedulePermissionList == '84'">
                <a class="nav-link" routerLinkActive="active" routerLink="/ScheduleMaster">
                    <span class="menuIcon"><i class="fa fa-calendar"></i></span>Schedule Masters
                </a>
            </li>
           
            <!-- <li class="nav-item" (click)="addClassActive()">
                <a class="nav-link" routerLinkActive="active" routerLink="/Taskmaster">
                    <span class="menuIcon"><i class="fa fa-tasks"></i></span>Task Masters
                </a>
            </li> -->
            <!-- <li class="nav-item" (click)="addClassActive()">
                <a class="nav-link" routerLinkActive="active" routerLink="/Field">
                    <span class="menuIcon"><i class="fa fa-columns"></i></span>Fields
                </a>
            </li> -->
            <li class="nav-item" (click)="addClassActive()"
                *ngIf="userPermissionList == '25' || userPermissionList == '48' || userPermissionList == '67' ||  userPermissionList == '86' || 
                (userPermissionList == '25,48,67') || (userPermissionList == '25,48,86') || (userPermissionList == '25,67,86') || (userPermissionList == '48,67,86') || 
                (userPermissionList == '25,48') || (userPermissionList == '25,67') || (userPermissionList == '25,86') || (userPermissionList == '48,67') || (userPermissionList == '48,86') || (userPermissionList == '67,86')  || 
                (userPermissionList == '25,48,67,86') ">
                <a class="nav-link" routerLinkActive="active" routerLink="/User">
                    <span class="menuIcon"><i class="fa fa-users"></i></span> Users
                </a>
            </li>
            <!-- <li class="nav-item" (click)="addClassActive()">
                <a class="nav-link"  routerLinkActive="active" routerLink="/AppConfiguration">
                    <span class="menuIcon"><i class="fa fa-cog"></i></span> App Configurations
                </a>
            </li> -->
            <!-- <li class="nav-item" (click)="addClassActive()">
                <a class="nav-link">
                    <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Insurance Workbench
                </a>
            </li> -->
            <!-- <li class="nav-item" (click)="addClassActive()" *ngIf="auditReportPermissionList == '24' || insACQauditReportPermissionList =='47' || insuranceFormauditReportPermissionList =='66' || mceauditReportPermissionList =='85'">
                <a class="nav-link collapsed text-truncate" (click)="isCollapsed = !isCollapsed"
                    routerLinkActive="active" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
                    <span class="menuIcon"><i class="fa fa-bar-chart"></i></span>Reports

                </a>
                <ul class="flex-column pl-2 nav" id="collapseBasic" [collapse]="isCollapsed">
                    <li class="nav-item"><a class="nav-link py-0" routerLinkActive="active" routerLink="/Report">
                            <span class="menuIcon"><i class="fa fa-credit-card"></i></span>Audit Report
                        </a></li>

                </ul>
            </li> -->

            <!-- <li class="nav-item" (click)="addClassActive()" *ngIf="uploadWorkbenchPermissionList == '22' || insACQuploadWorkbenchPermissionList == '45'">
                <a class="nav-link" routerLinkActive="active" [routerLink]="['/Upload']" >
                    <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Upload Workbench Master Data
                </a>
            </li>

            <li class="nav-item" (click)="addClassActive()" *ngIf="uploadWorkbenchPermissionList == '22' || insACQuploadWorkbenchPermissionList == '45'">
                <a class="nav-link" routerLinkActive="active" [routerLink]="['/UploadMissedData']" >
                    <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Missed Action Data Validation
                </a>
            </li> -->

            <li class="nav-item" (click)="addClassActive()" *ngIf="uploadWorkbenchPermissionList == '22' || insACQuploadWorkbenchPermissionList == '45' || insuranceFormuploadWorkbenchPermissionList == '64' || mceuploadWorkbenchPermissionList == '83'">
                <a class="nav-link" routerLinkActive="active" [routerLink]="['/Upload']" >
                    <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Upload Workbench Master Data
                </a>
            </li>
             <li class="nav-item" (click)="addClassActive()" *ngIf="getCrawledDataPermissionList == '114'">
                <a class="nav-link" routerLinkActive="active" [routerLink]="['/GetCrawledDataList']" >
                    <span class="menuIcon"><i class="fa fa-database"></i></span>Get Crawled Data
                </a>
            </li>
            <li class="nav-item" (click)="addClassActive()" *ngIf="manageSummaryParameterMappingPermissionList == '115'">
                <a class="nav-link" routerLinkActive="active" [routerLink]="['/SummaryGenerationParameterMapping']">
                    <span class="menuIcon"><i class="fa fa-file-text"></i></span>Summary Generation Parameter Mapping
                </a>
            </li>
            <li class="nav-item" (click)="addClassActive()" *ngIf="syncRCMDataPermissionList == '103'">
                <a class="nav-link" routerLinkActive="active" [routerLink]="['/SyncRcmMasterDataComponent']">
                    <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Sync RCM Master Data
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link collapsed text-truncate" (click)="isCollapsed = !isCollapsed" routerLinkActive="active"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
                    <span class="menuIcon"><i class="fa fa-bar-chart"></i></span>Review Data
            
                </a>
                <ul class="flex-column pl-2 nav" id="collapseBasic" [collapse]="isCollapsed">
                    <!-- <li class="nav-item" (click)="addClassActive()" *ngIf="reviewCrawlPermissionList == '87' || reviewCrawlPermissionList == '88' || reviewCrawlPermissionList == '89' || reviewCrawlPermissionList == '90'">
                                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/ReviewCrawledDataList']" >
                                        <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Review Crawled Data List
                                    </a>
                                </li> -->
                    <li class="nav-item" (click)="addClassActive()"
                        *ngIf="missedActionPermissionList == '91' || missedActionPermissionList == '92' || missedActionPermissionList == '93' || missedActionPermissionList == '94'">
                        <a class="nav-link" routerLinkActive="active" [routerLink]="['/MissedActionDataHistory']">
                            <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Missed Action Data Validation
                        </a>
                    </li>
                    <li class="nav-item" (click)="addClassActive()"
                        *ngIf="instanceAndSchedulesPermissionList == '95' || instanceAndSchedulesPermissionList == '96' || instanceAndSchedulesPermissionList == '97' || instanceAndSchedulesPermissionList == '98'">
                        <a class="nav-link" routerLinkActive="active" [routerLink]="['/UrlInstancesAndSchedulesListComponent']">
                            <span class="menuIcon"><i class="fa fa-briefcase"></i></span>URL Instances and Schedules List
                        </a>
                    </li>
            
                    <li class="nav-item" (click)="addClassActive()"
                        *ngIf="missedDataPermissionList == '99' || missedDataPermissionList == '100' || missedDataPermissionList == '101' || missedDataPermissionList == '102'">
                        <a class="nav-link" routerLinkActive="active" [routerLink]="['/ReviewMissedDataListComponent']">
                            <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Review Missed Action Data
                        </a>
                    </li>
            
                    <li class="nav-item" (click)="addClassActive()" *ngIf="manageRecrawlURLConfigPermissionList == '116'">
                        <a class="nav-link" routerLinkActive="active" [routerLink]="['/RecrawlUrlConfiguration']">
                            <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Recrawl URLConfiguration Data
                        </a>
                    </li>
                    <li class="nav-item" (click)="addClassActive()" *ngIf="manageQueryBuilderPermissionList == '117' || manageQueryBuilderPermissionList == '118' || (manageQueryBuilderPermissionList == '117,118')">
                        <a class="nav-link" routerLinkActive="active" [routerLink]="['/QueryBuilderComponent']">
                            <span class="menuIcon"><i class="fa fa-code"></i></span>Query Builder
                        </a>
                    </li>
    
                    <!-- <li class="nav-item" (click)="addClassActive()" *ngIf="syncRCMDataPermissionList == '103'">
                        <a class="nav-link" routerLinkActive="active" [routerLink]="['/SyncRcmMasterDataComponent']" >
                            <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Sync RCM Master Data
                        </a>
                    </li>             -->
                               
                </ul>
            </li>
        </ul>
    </div>
</nav>

  
  
  


   
    <!-- <div class="scrollingContent"> -->
        <!-- <scrollbar style="max-height: 100%; height: 100%;
        background: #2A3D64;" fxFlex="auto" [config]="config" [scrollIndicators]="true" > -->
            <!-- <ul id="accordion" class="nav nav-pills flex-column sidebarNavigation">
                <li class="nav-item" (click)="addClassActive()" *ngIf="schedulePermissionList == '23' || insACQschedulePermissionList == '46' || insuranceFormschedulePermissionList == '65' || mceschedulePermissionList == '84'">
                    <a class="nav-link" routerLinkActive="active" routerLink="/ScheduleMaster">
                        <span class="menuIcon"><i class="fa fa-calendar"></i></span>Schedule Masters
                    </a>
                </li> -->
               
                <!-- <li class="nav-item" (click)="addClassActive()">
                    <a class="nav-link" routerLinkActive="active" routerLink="/Taskmaster">
                        <span class="menuIcon"><i class="fa fa-tasks"></i></span>Task Masters
                    </a>
                </li> -->
                <!-- <li class="nav-item" (click)="addClassActive()">
                    <a class="nav-link" routerLinkActive="active" routerLink="/Field">
                        <span class="menuIcon"><i class="fa fa-columns"></i></span>Fields
                    </a>
                </li> -->
                <!-- <li class="nav-item" (click)="addClassActive()"
                    *ngIf="userPermissionList == '25' || userPermissionList == '48' || userPermissionList == '67' ||  userPermissionList == '86' || 
                    (userPermissionList == '25,48,67') || (userPermissionList == '25,48,86') || (userPermissionList == '25,67,86') || (userPermissionList == '48,67,86') || 
                    (userPermissionList == '25,48') || (userPermissionList == '25,67') || (userPermissionList == '25,86') || (userPermissionList == '48,67') || (userPermissionList == '48,86') || (userPermissionList == '67,86')  || 
                    (userPermissionList == '25,48,67,86') ">
                    <a class="nav-link" routerLinkActive="active" routerLink="/User">
                        <span class="menuIcon"><i class="fa fa-users"></i></span> Users
                    </a>
                </li> -->
                <!-- <li class="nav-item" (click)="addClassActive()">
                    <a class="nav-link"  routerLinkActive="active" routerLink="/AppConfiguration">
                        <span class="menuIcon"><i class="fa fa-cog"></i></span> App Configurations
                    </a>
                </li> -->
                <!-- <li class="nav-item" (click)="addClassActive()">
                    <a class="nav-link">
                        <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Insurance Workbench
                    </a>
                </li> -->
                <!-- <li class="nav-item" (click)="addClassActive()" *ngIf="auditReportPermissionList == '24' || insACQauditReportPermissionList =='47' || insuranceFormauditReportPermissionList =='66' || mceauditReportPermissionList =='85'">
                    <a class="nav-link collapsed text-truncate" (click)="isCollapsed = !isCollapsed"
                        routerLinkActive="active" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
                        <span class="menuIcon"><i class="fa fa-bar-chart"></i></span>Reports

                    </a>
                    <ul class="flex-column pl-2 nav" id="collapseBasic" [collapse]="isCollapsed">
                        <li class="nav-item"><a class="nav-link py-0" routerLinkActive="active" routerLink="/Report">
                                <span class="menuIcon"><i class="fa fa-credit-card"></i></span>Audit Report
                            </a></li>

                    </ul>
                </li> -->

                <!-- <li class="nav-item" (click)="addClassActive()" *ngIf="uploadWorkbenchPermissionList == '22' || insACQuploadWorkbenchPermissionList == '45'">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/Upload']" >
                        <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Upload Workbench Master Data
                    </a>
                </li>

                <li class="nav-item" (click)="addClassActive()" *ngIf="uploadWorkbenchPermissionList == '22' || insACQuploadWorkbenchPermissionList == '45'">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/UploadMissedData']" >
                        <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Missed Action Data Validation
                    </a>
                </li> -->

                <!-- <li class="nav-item" (click)="addClassActive()" *ngIf="uploadWorkbenchPermissionList == '22' || insACQuploadWorkbenchPermissionList == '45' || insuranceFormuploadWorkbenchPermissionList == '64' || mceuploadWorkbenchPermissionList == '83'">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/Upload']" >
                        <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Upload Workbench Master Data
                    </a>
                </li>
                <li class="nav-item" >
                    <a class="nav-link collapsed text-truncate" (click)="isCollapsed = !isCollapsed"
                        routerLinkActive="active" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
                        <span class="menuIcon"><i class="fa fa-bar-chart"></i></span>Review Data

                    </a>
                    <ul class="flex-column pl-2 nav" id="collapseBasic" [collapse]="isCollapsed">
                        <li class="nav-item" (click)="addClassActive()" *ngIf="reviewCrawlPermissionList == '87' || reviewCrawlPermissionList == '88' || reviewCrawlPermissionList == '89' || reviewCrawlPermissionList == '90'">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/ReviewCrawledDataList']" >
                                <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Review Crawled Data List
                            </a>
                        </li>
                        <li class="nav-item" (click)="addClassActive()" *ngIf="missedActionPermissionList == '91' || missedActionPermissionList == '92' || missedActionPermissionList == '93' || missedActionPermissionList == '94'">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/MissedActionDataHistory']" >
                                <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Missed Action Data Validation
                            </a>
                        </li>
                        <li class="nav-item" (click)="addClassActive()" *ngIf="instanceAndSchedulesPermissionList == '95' || instanceAndSchedulesPermissionList == '96' || instanceAndSchedulesPermissionList == '97' || instanceAndSchedulesPermissionList == '98'">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/UrlInstancesAndSchedulesListComponent']" >
                                <span class="menuIcon"><i class="fa fa-briefcase"></i></span>URL Instances and Schedules List
                            </a>
                        </li>
                        
                        <li class="nav-item" (click)="addClassActive()" *ngIf="missedDataPermissionList == '99' || missedDataPermissionList == '100' || missedDataPermissionList == '101' || missedDataPermissionList == '102'">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/ReviewMissedDataListComponent']" >
                                <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Review Missed Action Data
                            </a>
                        </li>
        
                        <li class="nav-item" (click)="addClassActive()" *ngIf="syncRCMDataPermissionList == '103'">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/SyncRcmMasterDataComponent']" >
                                <span class="menuIcon"><i class="fa fa-briefcase"></i></span>Sync RCM Master Data
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

      </perfect-scrollbar> 
    </div> -->
